module.exports = __webpack_public_path__ + "static/img/DSC_2645.b753f7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2645.jpg
// module id = 266
// module chunks = 0